import React, { useState } from "react";
import PropDetailsSec from "../sections/propertyDetail/PropDetailsSec";
import Breadcrumb from "../components/Breadcrumb";
import { useParams } from 'react-router-dom';
import * as constants from "../constants";
import { fetchAPI } from "../helper/fetchAPI";
import { decodeId, detectScript, encodeId, getDecodedPathParam, replacePathParams, slugify } from "../helper/helperFunction";
import CustomHelmet from "../components/CustomHelmet";
import { t } from "i18next";
import FullScreenLoader from "../components/FullScreenLoader";
import { useTranslation } from "react-i18next";
import { useCountryPrefix } from "../routes/useCountryPrefix";
import NotFoundSec from "../sections/pageNotFound/NotFoundSec";

const PropertyDetail = () => {
  let apiUrl = process.env.REACT_APP_API_URL;
  let langUrl = process.env.REACT_APP_API_URL;

  const { i18n } = useTranslation();
  const countryPrefix = useCountryPrefix();

  const { developerName, projectName, idTitle, idProperty } = useParams();
  const [propertyData, setPropertyData] = useState();
  const isArabic = i18n.language === "ar";
  const [isLoaded, setIsLoaded] = useState(false);

  const fetchData = async () => {
    try {
      const language = isArabic ? "ar" : "en";
      apiUrl = `${apiUrl}${constants.propertydetail}/${decodeId(idProperty)}?language=${language}&region_id=${countryPrefix}`;

      const res = await fetchAPI(apiUrl, "Get");
      if (res?.status === 200) {
        setPropertyData(res?.data)
        setIsLoaded(true)
      } else {
        setIsLoaded(true)

      }

      const currentUrl = window.location.href;
      let replacement = {};

      let convPathDeveloperName = getDecodedPathParam(currentUrl, "developers/:developerName/project/:projectName/property/:idTitle/:idProperty", "developerName")
      let convPathprojectName = getDecodedPathParam(currentUrl, "developers/:developerName/project/:projectName/property/:idTitle/:idProperty", "projectName")
      let convPathidTitle = getDecodedPathParam(currentUrl, "developers/:developerName/project/:projectName/property/:idTitle/:idProperty", "idTitle")

      if ((language === "en" && (detectScript(convPathDeveloperName) === "arabic" || detectScript(convPathprojectName) === "arabic" || detectScript(convPathidTitle) === "arabic")) || (language === "ar" && (detectScript(convPathDeveloperName) === "english" || detectScript(convPathprojectName) === "english" || detectScript(convPathidTitle) === "english"))) {

        langUrl = `${langUrl}${constants.localization}?DeveloperName=${developerName}&ProjectName=${projectName}&PropertyName=${idTitle}`
        const res = await fetchAPI(langUrl, "Get");

        const pattern = `${countryPrefix}${language === "ar" ? "/ar" : ""}/developers/:developerName/project/:projectName/property/:idTitle/:idProperty`;
        replacement = {
          developerName: slugify(isArabic ? res.data.developerName.ar : res.data.developerName.en),
          projectName: slugify(isArabic ? res.data.projectName.ar : res.data.projectName.en),
          idTitle: slugify(isArabic ? res.data.propertyName.ar : res.data.propertyName.en),


        }
        var newUrl = replacePathParams(currentUrl, pattern, replacement)

        window.history.replaceState({}, '', newUrl);

      }

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  // const pathName = [{ name: "Home", path: "/" }];
  const pathLang = isArabic ? "/ar" : "";
  const pathName = [
    { name: t("home"), path: `/${countryPrefix}${pathLang ? `${pathLang}` : ""}` },
    { name: t("developers"), path: `/${countryPrefix}${pathLang ? `${pathLang}` : ""}/developers` },
    { name: propertyData?.developerDetails?.developerName || "", path: `/${countryPrefix}${pathLang ? `${pathLang}` : ""}/developers/${slugify(propertyData?.developerDetails?.developerName)}/${encodeId((propertyData?.developerDetails?.developerId))}` },
    { name: propertyData?.projectDetails?.projectName || "", path: `/${countryPrefix}${pathLang ? `${pathLang}` : ""}/developers/${slugify(propertyData?.developerDetails?.developerName)}/project/${slugify(propertyData?.projectDetails?.projectName)}/${encodeId((propertyData?.projectDetails?.projectId))}` },
    { name: `${propertyData?.projectDetails?.projectName} ${propertyData?.propertyDetails?.features?.areaSqft}${t("Metersq")} ${t(constants.defaultPropertyType[propertyData?.propertyDetails?.propertyType]?.label)}` || "" },
  ];

  if (!isLoaded) {
    return (
      <FullScreenLoader />
    )
  }

  return (
    <>
      <CustomHelmet
        title={"Exclusive Real Estate Across Egypt"}
        desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
      />
      <Breadcrumb pathName={pathName} />
      {propertyData !== undefined && propertyData !== null ? (
        <PropDetailsSec data={propertyData} />
      ) : (
        <NotFoundSec title={t("opps")} desc={t("property_not_found")} img={"/assets/img/not-found.svg"} />
      )}


    </>
  );
};

export default PropertyDetail;
